/* Andy Cooks – recipe comments & ratings (Recipes by Andy reviews)
   GET  /apps/recipe-reviews?recipeId=…  -> { success, averageRating, reviewCount, commentCount, reviews:[{ id, parentReviewId, displayName, rating, comment, submittedAt }] }
   POST /apps/recipe-reviews (FormData)   -> { success, message, fieldErrors|errors }  (held for approval)
   Also fills the stars at the top of the recipe and the Google rating data. Text is always inserted as text, never HTML. */
(function () {
  'use strict';
  var acT = function (k, f, v) { var s = (window.AC_I18N && window.AC_I18N[k]) || f; if (v) { for (var n in v) { s = s.split('__' + n + '__').join(v[n]); } } return s; };
  var root = document.querySelector('[data-acr-reviews]');
  if (!root) return;
  var gid = root.getAttribute('data-recipe-gid');
  if (!gid || /\/$/.test(gid)) return;
  var API = '/apps/recipe-reviews';
  var PAGE = 6;
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17.1l-6.1 3.5 1.5-6.8-5.2-4.6 6.9-.7z"/></svg>';
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var list = $('[data-rev-list]'), more = $('[data-rev-more]'), form = $('[data-rev-form]');
  var tops = [], replies = {}, shown = PAGE;

  /* ---------- Cloudflare Turnstile spam check (widget: Andy Cooks Recipe Comments Captcha) ----------
     The widget puts a hidden "cf-turnstile-response" field in the form, so the token goes to the app with the post.
     The app's server should check it with Cloudflare (secret key on Render). */
  var TSKEY = root.getAttribute('data-ts-key') || '', tsQueue = [], tsReady = false;
  function tsLoad(cb) {
    if (!TSKEY) return;
    if (tsReady && window.turnstile) return cb();
    tsQueue.push(cb);
    if (document.getElementById('ac-ts-api')) return;
    window.acRevTsReady = function () { tsReady = true; var q = tsQueue.slice(); tsQueue = []; q.forEach(function (f) { f(); }); };
    var sc = document.createElement('script'); sc.id = 'ac-ts-api'; sc.async = true; sc.defer = true;
    sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=acRevTsReady';
    document.head.appendChild(sc);
  }
  function tsMount(box, formEl) {
    if (!TSKEY || !box) return;
    tsLoad(function () {
      try {
        formEl._tsId = window.turnstile.render(box, {
          sitekey: TSKEY, theme: 'light', size: 'flexible',
          callback: function () { formEl.dataset.tsOk = '1'; var e = box.parentNode.querySelector('.acr-rev__tserr'); if (e) e.remove(); },
          'expired-callback': function () { formEl.dataset.tsOk = ''; },
          'error-callback': function () { formEl.dataset.tsOk = ''; }
        });
      } catch (e) {}
    });
  }
  function tsPassed(formEl) { return !TSKEY || formEl.dataset.tsOk === '1'; }
  function tsReset(formEl) { if (!TSKEY) return; formEl.dataset.tsOk = ''; try { window.turnstile.reset(formEl._tsId); } catch (e) {} }
  function tsNeed(box) {
    if (!box) return;
    var e = box.parentNode.querySelector('.acr-rev__tserr');
    if (!e) { e = el('p', 'acr-rev__tserr', acT('ac.js.reviews.spam_check', 'Please complete the spam check below the comment box.')); box.insertAdjacentElement('afterend', e); }
  }

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function starsHTML(v, size) {
    var pct = Math.max(0, Math.min(100, v / 5 * 100));
    return '<span class="acr-rev__stars acr-rev__stars--' + (size || 'sm') + '" aria-label="' + acT('ac.js.reviews.rated_out_of_5', 'Rated __rating__ out of 5', { rating: v }) + '"><span class="acr-rev__row">' + STAR + STAR + STAR + STAR + STAR + '</span><span class="acr-rev__fill" style="width:' + pct + '%"><span class="acr-rev__row">' + STAR + STAR + STAR + STAR + STAR + '</span></span></span>';
  }
  function fmtDate(v) {
    var d = new Date(v); if (isNaN(d)) return '';
    var same = d.getFullYear() === new Date().getFullYear();
    return d.toLocaleDateString('en-AU', same ? { day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short', year: 'numeric' });
  }
  function initial(n) { n = (n || '').trim(); return n ? n.charAt(0).toUpperCase() : '?'; }
  function tone(n) { var h = 0; for (var i = 0; i < (n || '').length; i++) h = (h * 31 + n.charCodeAt(i)) >>> 0; return h % 5; }

  /* ---------- summary + hero stars + Google data ---------- */
  function summary(avg, count, comments, dist) {
    var a = Math.round((avg || 0) * 10) / 10;
    $('[data-rev-avg]').textContent = count ? a.toFixed(1) : '–';
    $('[data-rev-fill]').style.width = (count ? a / 5 * 100 : 0) + '%';
    $('[data-rev-counts]').textContent = count
      ? (count === 1 ? acT('ac.js.reviews.ratings_one', '__count__ rating', { count: count }) : acT('ac.js.reviews.ratings_other', '__count__ ratings', { count: count })) + (comments ? ' · ' + (comments === 1 ? acT('ac.js.reviews.comments_one', '__count__ comment', { count: comments }) : acT('ac.js.reviews.comments_other', '__count__ comments', { count: comments })) : '')
      : acT('ac.js.reviews.no_ratings', 'No ratings yet. Be the first to rate it!');
    var bars = $('[data-rev-bars]'); bars.innerHTML = '';
    if (count) for (var s = 5; s >= 1; s--) {
      var n = dist[s] || 0, li = el('li');
      li.innerHTML = '<span class="acr-rev__bl">' + s + ' ' + STAR + '</span><span class="acr-rev__bt"><i style="width:' + (n / count * 100) + '%"></i></span><span class="acr-rev__bn"></span>';
      li.querySelector('.acr-rev__bn').textContent = n;
      bars.appendChild(li);
    }
    hero(a, count);
    ld(a, count);
  }
  function hero(a, count) {
    var box = document.querySelector('[data-rev-hero]'); if (!box) return;
    var link = box.querySelector('.acr-stars'); if (!link) return;
    var fill = link.querySelector('.acr-stars__fill');
    if (!fill) { fill = el('span', 'acr-stars__fill'); fill.innerHTML = '<span class="acr-stars__row">' + STAR + STAR + STAR + STAR + STAR + '</span>'; link.appendChild(fill); }
    fill.style.width = (count ? a / 5 * 100 : 0) + '%';
    link.setAttribute('aria-label', count ? acT('ac.js.reviews.rated_from', 'Rated __rating__ out of 5 from __count__ ratings', { rating: a, count: count }) : acT('ac.js.reviews.be_first', 'Be the first to rate this recipe'));
    var c = box.querySelector('.acr-stars__count');
    if (count) { if (!c) { c = el('span', 'acr-stars__count'); c.style.marginLeft = '-22px'; link.insertAdjacentElement('afterend', c); } c.textContent = '(' + count + ')'; }
    else if (c) c.remove();
  }
  function ld(a, count) {
    [].forEach.call(document.querySelectorAll('script[type="application/ld+json"]'), function (s) {
      try {
        var j = JSON.parse(s.textContent); if (!j || j['@type'] !== 'Recipe') return;
        if (count) j.aggregateRating = { '@type': 'AggregateRating', ratingValue: a, ratingCount: count }; else delete j.aggregateRating;
        s.textContent = JSON.stringify(j);
      } catch (e) {}
    });
  }

  /* ---------- list ---------- */
  function card(r, isReply) {
    var a = el('article', 'acr-rev__item' + (isReply ? ' acr-rev__item--reply' : ''));
    var av = el('span', 'acr-rev__av acr-rev__av--' + tone(r.displayName), initial(r.displayName)); av.setAttribute('aria-hidden', 'true');
    var body = el('div', 'acr-rev__body');
    var head = el('div', 'acr-rev__head');
    head.appendChild(el('b', 'acr-rev__name', r.displayName || acT('ac.js.reviews.anonymous', 'Anonymous')));
    if (/^andy\b/i.test(r.displayName || '') && isReply) head.appendChild(el('span', 'acr-rev__badge', 'Andy Cooks'));
    var t = el('time', 'acr-rev__date', fmtDate(r.submittedAt)); t.setAttribute('datetime', r.submittedAt || ''); head.appendChild(t);
    body.appendChild(head);
    if (!isReply && r.rating > 0) { var st = el('div', 'acr-rev__rs'); st.innerHTML = starsHTML(r.rating, 'sm'); body.appendChild(st); }
    body.appendChild(el('p', 'acr-rev__text', r.comment || ''));
    if (!isReply) {
      var rb = el('button', 'acr-rev__replybtn', acT('ac.js.reviews.reply', 'Reply')); rb.type = 'button';
      rb.addEventListener('click', function () { replyForm(r, body, rb); });
      body.appendChild(rb);
      var kids = replies[r.id] || [];
      if (kids.length) { var wrap = el('div', 'acr-rev__replies'); kids.forEach(function (k) { wrap.appendChild(card(k, true)); }); body.appendChild(wrap); }
    }
    a.appendChild(av); a.appendChild(body);
    return a;
  }
  function render() {
    list.innerHTML = '';
    if (!tops.length) { list.appendChild(el('p', 'acr-rev__empty', acT('ac.js.reviews.no_comments', 'No comments yet. Cooked it? Be the first to tell us how it went.'))); more.hidden = true; return; }
    tops.slice(0, shown).forEach(function (r) { list.appendChild(card(r)); });
    more.hidden = shown >= tops.length;
    if (!more.hidden) more.textContent = acT('ac.js.reviews.show_more', 'Show more comments (__count__)', { count: tops.length - shown });
  }
  more.addEventListener('click', function () { shown += 10; render(); });

  function load() {
    fetch(API + '?recipeId=' + encodeURIComponent(gid), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.success === false) throw new Error('bad');
        var all = d.reviews || [], dist = {};
        tops = []; replies = {};
        all.forEach(function (r) {
          if (r.parentReviewId) (replies[r.parentReviewId] = replies[r.parentReviewId] || []).push(r);
          else { tops.push(r); if (r.rating > 0) dist[r.rating] = (dist[r.rating] || 0) + 1; }
        });
        tops.sort(function (a, b) { return new Date(b.submittedAt) - new Date(a.submittedAt); });
        Object.keys(replies).forEach(function (k) { replies[k].sort(function (a, b) { return new Date(a.submittedAt) - new Date(b.submittedAt); }); });
        summary(d.averageRating || 0, d.reviewCount || 0, d.commentCount || tops.length, dist);
        render();
      })
      .catch(function () {
        $('[data-rev-counts]').textContent = acT('ac.js.reviews.ratings_loading', 'Ratings are taking a moment to load.');
        list.innerHTML = ''; list.appendChild(el('p', 'acr-rev__empty', acT('ac.js.reviews.load_error', 'Comments couldn’t load just now. Please refresh to try again.')));
      });
  }

  /* ---------- star picker ---------- */
  /* nudge: the stars wave while the form is on screen, until the reader touches them */
  var pick = $('[data-rev-pick]');
  if (pick) {
    var stopNudge = function () { pick.classList.remove('is-nudge'); pick.dataset.touched = '1'; };
    ['pointerenter', 'focusin', 'change', 'touchstart'].forEach(function (ev) { pick.addEventListener(ev, stopNudge, { passive: true }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (pick.dataset.touched) return; pick.classList.toggle('is-nudge', e.isIntersecting); });
      }, { threshold: 0.4 }).observe(pick);
    } else pick.classList.add('is-nudge');
  }
  var WORDS = { 1: acT('ac.js.reviews.rating_1', 'Not for me'), 2: acT('ac.js.reviews.rating_2', 'It was OK'), 3: acT('ac.js.reviews.rating_3', 'Good'), 4: acT('ac.js.reviews.rating_4', 'Really good'), 5: acT('ac.js.reviews.rating_5', 'Absolutely loved it') };
  var pickTxt = $('[data-rev-picktxt]');
  [].forEach.call(form.querySelectorAll('input[name="rating"]'), function (i) {
    i.addEventListener('change', function () { pickTxt.textContent = WORDS[i.value]; pickTxt.classList.add('is-set'); clearErr('rating'); });
  });
  /* start on 5 stars (the reader can still tap a lower one); no waving stars needed */
  var def5 = form.querySelector('input[name="rating"][value="5"]');
  if (def5 && !form.querySelector('input[name="rating"]:checked')) {
    def5.checked = true; pickTxt.textContent = WORDS[5]; pickTxt.classList.add('is-set');
    if (pick) { pick.dataset.touched = '1'; pick.classList.remove('is-nudge'); }
  }

  /* ---------- posting ---------- */
  var msg = $('[data-rev-msg]'), btn = form.querySelector('.acr-rev__submit');
  var tsBox = $('[data-rev-ts]');
  /* only load Cloudflare once the form is close to view (keeps the recipe page fast) */
  if (TSKEY && tsBox) {
    if ('IntersectionObserver' in window) { var tsIO = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { tsIO.disconnect(); tsMount(tsBox, form); } }, { rootMargin: '600px 0px' }); tsIO.observe(form); }
    else tsMount(tsBox, form);
  }
  function setErr(name, text) {
    var f = name === 'rating' ? $('[data-rev-pick]') : form.querySelector('[name="' + name + '"]');
    if (!f) return false;
    var host = name === 'rating' ? f : f.closest('.acr-rev__fld');
    host.classList.add('has-err');
    var e = host.querySelector('.acr-rev__err'); if (!e) { e = el('span', 'acr-rev__err'); host.appendChild(e); }
    e.textContent = text; return true;
  }
  function clearErr(name) {
    var host;
    if (name === 'rating') host = $('[data-rev-pick]');
    else { var f = form.querySelector('[name="' + name + '"]'); host = f && f.closest('.acr-rev__fld'); }
    if (!host) return; host.classList.remove('has-err'); var e = host.querySelector('.acr-rev__err'); if (e) e.remove();
  }
  ['displayName', 'email', 'comment'].forEach(function (n) { var f = form.querySelector('[name="' + n + '"]'); if (f) f.addEventListener('input', function () { clearErr(n); }); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    msg.textContent = ''; msg.className = 'acr-rev__msg';
    var name = form.displayName.value.trim(), email = form.email.value.trim(), comment = form.comment.value.trim();
    var picked = form.querySelector('input[name="rating"]:checked'), bad = '';
    if (!picked) { setErr('rating', acT('ac.js.reviews.err_rating', 'Please choose a star rating.')); bad = bad || 'rating'; }
    if (!name) { setErr('displayName', acT('ac.js.reviews.err_name', 'Please add your name.')); bad = bad || 'displayName'; }
    if (!email) { setErr('email', acT('ac.js.reviews.err_email', 'Please add your email.')); bad = bad || 'email'; }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setErr('email', acT('ac.js.reviews.err_email_invalid', 'That email doesn’t look right.')); bad = bad || 'email'; }
    if (!comment) { setErr('comment', acT('ac.js.reviews.err_comment', 'Please add a comment.')); bad = bad || 'comment'; }
    if (bad) { var f = bad === 'rating' ? form.querySelector('input[name="rating"]') : form[bad]; if (f) f.focus(); return; }
    if (!tsPassed(form)) { tsNeed(tsBox); return; }
    var fd = new FormData(form); fd.set('displayName', name); fd.set('email', email); fd.set('comment', comment); fd.set('rating', picked.value);
    btn.disabled = true; btn.textContent = acT('ac.js.reviews.posting', 'Posting…');
    fetch(API, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        var d = res.d;
        if (!res.ok || !d || !d.success) {
          var errs = d && (d.fieldErrors || d.errors);
          if (errs && typeof errs === 'object' && !Array.isArray(errs)) Object.keys(errs).forEach(function (k) { setErr(k, [].concat(errs[k]).join(' ')); });
          msg.textContent = (d && typeof d.message === 'string') ? d.message : acT('ac.js.reviews.send_error', 'Sorry, that didn’t send. Please try again.');
          msg.classList.add('is-err');
          return;
        }
        form.hidden = true;
        var th = $('[data-rev-thanks]'); th.hidden = false; requestAnimationFrame(function () { th.classList.add('is-on'); });
        th.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function () { msg.textContent = acT('ac.js.reviews.send_error_connection', 'Sorry, that didn’t send. Please check your connection and try again.'); msg.classList.add('is-err'); })
      .then(function () { btn.disabled = false; btn.textContent = acT('ac.js.reviews.post_comment', 'Post comment'); tsReset(form); });
  });

  /* ---------- replies ---------- */
  function replyForm(parent, host, trigger) {
    var open = host.querySelector('.acr-rev__rform'); if (open) { open.remove(); trigger.setAttribute('aria-expanded', 'false'); return; }
    trigger.setAttribute('aria-expanded', 'true');
    var f = el('form', 'acr-rev__rform'); f.noValidate = true;
    f.innerHTML = '<div class="acr-rev__row2"><label class="acr-rev__fld"><span>' + acT('ac.js.reviews.label_name', 'Name') + '</span><input name="displayName" type="text" autocomplete="name" maxlength="80" required></label>' +
      '<label class="acr-rev__fld"><span>' + acT('ac.js.reviews.label_email', 'Email') + ' <em>' + acT('ac.js.reviews.never_shown', 'never shown') + '</em></span><input name="email" type="email" autocomplete="email" maxlength="120" required></label></div>' +
      '<label class="acr-rev__fld"><span>' + acT('ac.js.reviews.reply', 'Reply') + '</span><textarea name="comment" rows="3" maxlength="2000" required></textarea></label>' +
      '<div class="acr-rev__ts"></div>' +
      '<div class="acr-rev__actions"><button type="submit" class="acr-rev__submit acr-rev__submit--sm">' + acT('ac.js.reviews.post_reply', 'Post reply') + '</button><p class="acr-rev__msg" role="status" aria-live="polite"></p></div>';
    var rbtn = f.querySelector('button'), rmsg = f.querySelector('.acr-rev__msg');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = f.displayName.value.trim(), em = f.email.value.trim(), c = f.comment.value.trim();
      if (!n || !c || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { rmsg.textContent = acT('ac.js.reviews.err_reply', 'Please add your name, a valid email and your reply.'); rmsg.className = 'acr-rev__msg is-err'; return; }
      if (!tsPassed(f)) { tsNeed(f.querySelector('.acr-rev__ts')); return; }
      var fd = new FormData(f); fd.set('recipeId', gid); fd.set('parentReviewId', parent.id);
      rbtn.disabled = true; rbtn.textContent = acT('ac.js.reviews.posting', 'Posting…');
      fetch(API, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (d) {
          if (d && d.success) { f.innerHTML = ''; f.appendChild(el('p', 'acr-rev__msg is-ok', acT('ac.js.reviews.reply_thanks', 'Thanks! Your reply will show once it’s approved.'))); }
          else { rmsg.textContent = (d && d.message) || acT('ac.js.reviews.send_error', 'Sorry, that didn’t send. Please try again.'); rmsg.className = 'acr-rev__msg is-err'; rbtn.disabled = false; rbtn.textContent = acT('ac.js.reviews.post_reply', 'Post reply'); tsReset(f); }
        })
        .catch(function () { rmsg.textContent = acT('ac.js.reviews.send_error', 'Sorry, that didn’t send. Please try again.'); rmsg.className = 'acr-rev__msg is-err'; rbtn.disabled = false; rbtn.textContent = acT('ac.js.reviews.post_reply', 'Post reply'); });
    });
    host.insertBefore(f, host.querySelector('.acr-rev__replies'));
    tsMount(f.querySelector('.acr-rev__ts'), f);
    f.displayName.focus();
  }

  load();
})();
